import api from "./api/config";

export const addressService = {
  // Müşterinin adreslerini getir
  getCustomerAddresses: async (customerId) => {
    if (!customerId) {
      throw new Error("Müşteri ID'si gereklidir.");
    }
    try {
      const params = { customerId };
      console.log("AddressService: Adresler isteniyor, params:", params);
      // İstek için gerçek token header'ı interceptor tarafından eklenecek
      const response = await api.get("/customers/getCustomerAddresses", {
        params,
      });
      console.log("AddressService: Adresler yanıtı:", response);

      // Yanıt yapısını kontrol edelim (doğrudan dizi veya {status, data} varsayımı)
      if (Array.isArray(response)) {
        return response;
      } else if (
        response &&
        response.status === 1 &&
        Array.isArray(response.data)
      ) {
        return response.data;
      } else {
        console.warn("Beklenmeyen adres yanıtı yapısı:", response);
        return []; // Hata veya beklenmeyen yanıtta boş dizi dön
      }
    } catch (error) {
      console.error("AddressService Error fetching customer addresses:", error);
      throw new Error("Adresler getirilirken bir hata oluştu.");
    }
  },

  // Diğer adres fonksiyonları buraya eklenebilir (add, update, delete)
};

export default addressService;
